import {
  animate,
  useMotionValue,
  useSpring,
  useTransform,
} from 'framer-motion';
import { useEffect, useState } from 'react';

interface AnimatedNumberProps {
  value: number;
  format?: (value: number) => string;
  duration?: number;
}

export const AnimatedNumber = ({
  value,
  format,
  duration = 0,
}: AnimatedNumberProps) => {
  const motionValue = useMotionValue(value);
  const springValue = useSpring(motionValue, {
    stiffness: 100,
    damping: 20,
  });

  const displayValue = useTransform(springValue, (latest) =>
    format ? format(latest) : latest,
  );

  const [renderedValue, setRenderedValue] = useState(
    format ? format(value) : value,
  );

  useEffect(() => {
    const unsubscribe = displayValue.onChange((v) => {
      setRenderedValue(v);
    });

    return () => unsubscribe();
  }, [displayValue]);

  useEffect(() => {
    animate(motionValue, value, { duration });
  }, [motionValue, value]);

  return <span>{renderedValue}</span>;
};
